// eslint-disable-next-line no-restricted-imports
import { PrimaryButton, PrimaryButtonProps } from '@workday/canvas-kit-react/button';
import { createComponent } from '@workday/canvas-kit-react/common';
import { primaryButtonColors } from '@workday/wcp-cargo-react';

export const ThemedPrimaryButton = createComponent('button')({
  displayName: 'ThemedPrimaryButton',
  Component: ({ grow, ...props }: PrimaryButtonProps, ref, Element) => (
    <PrimaryButton
      ref={ref}
      as={Element}
      colors={primaryButtonColors(props)}
      maxWidth={grow ? '100%' : undefined}
      width={grow ? '100%' : undefined}
      {...props}
    />
  ),
});
